<template lang="pug">
el-dialog.dialog-general-note(:visible='visible', :before-close='exit', :show-close='false')
  h3.ui.header(slot='title')
    span {{ is_new ? '创建备忘录' : '编辑备忘录' }}
  el-form.ui.form
    .ui.field
      label 内容
      textarea(v-model='form.note')
    .ui.field
      label 标签
      el-select(v-model='form.tags', multiple, filterable, allow-create, placeholder='选择标签...')
        el-option(v-for='item in tags_candidates', :key='item', :label='item', :value='item')
    .ui.four.fields
      .ui.field
        label 创建人
        input(v-model='form._creator', disabled)
      .ui.field
        label 创建时间
        input(:value='$formatters.date.to_datetime(form.time_created)', disabled)
      .ui.field
        label 最后编辑
        input(v-model='form._modifier', disabled)
      .ui.field
        label 编辑时间
        input(:value='$formatters.date.to_datetime(form.time_modified)', disabled)
    .ui.field
      labeL 状态
      el-checkbox(v-model='form.state')
        span(v-if='form.state')
          | 已处理
          el-tooltip(content='已处理的项目会在未修改三天后自动消失', placement='top')
            i.icon.help.circle.semitrans
        span(v-else) 未处理
      el-checkbox(v-model='form.pinned') 置顶
      el-checkbox(v-model='form.collapsable')
        span 允许折叠
        el-tooltip(content='（暂不可用）允许系统在需要时以"..."的形式折叠过长的文本内容', placement='top')
          i.icon.help.circle.semitrans

  div(slot='footer')
    //.ui.button.basic.orange.icon.labeled(@click='toggle_checked()', v-show='!is_new')
      i.icon.checkmark
      span {{ form.checked ? '标记为已完成' : '标记为未完成' }}
    .ui.button.themed(@click='save') 保存
    .ui.button(@click='exit') 取消
</template>

<script>
const tags_candidates = [
  '维修',
  '公告',
  '交接',
  '系统更新',
  '系统问题',
  '功能需求',
]

export default {
  name: 'dialog-general-note',
  props: {
    item: Object,
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      form: [],
      tags_candidates,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    is_new() {
      return !this.form._id
    },
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.init()
      },
    },
    visible() {
      if (this.visible)
        this.init()
    },
  },
  methods: {
    init() {
      this.form = Object.assign(
        {
          pinned: false,
          state: false,
          collapsable: true,
          note: '',
          tags: [],
          time_modified: this.$moment(),
          time_created: this.$moment(),
          _modifier: this.$user.get_name(),
          _creator: this.$user.get_name(),
        },
        this.item
      )
    },
    toggle_checked() {
      this.form.state = !this.form.state
      this.save()
    },
    save() {
      this.form._modifier = this.$user.get_name()

      let req
      if (this.is_new)
        req = this.$http.post('notes', this.form)
      else
        req = this.$http.put(`notes/${this.form._id}`, this.form)

      req
        .then(r => {
          this.$store.commit('UPDATE_GENERAL_NOTES', r.body)
          this.exit()
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
    exit() {
      this.$emit('update:visible', false)
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogGeneralNote.vue?1544b9ba